import React, { Component } from 'react'
import { Modal, Form, Button } from 'antd'
import ExportForm from './ExportForm'

const CollectionCreateForm = Form.create({ name: 'export-checkins' })(

  class extends Component {
    render() {
      const { visible, isSubmit, onCancel, onCreate, form, singleRestaurant } = this.props
      const { getFieldDecorator } = form
      return (
        <Modal
          visible={visible}
          maskClosable={false}
          title={`Export Checkins`}
          onCancel={onCancel}
          onOk={onCreate}
          footer={[
            <Button key="back" onClick={onCancel}>Cancel</Button>,
            <Button key="submit" type="primary" loading={isSubmit} onClick={onCreate}>
              Submit
            </Button>
          ]}
        >
          <ExportForm
            singleRestaurant={singleRestaurant}
            showModal={visible}
            getFieldDecorator={getFieldDecorator}
          />
        </Modal>
      )
    }
  }
)

export default class ExportModal extends Component {
  render() {
    const { shoModal, isSubmit, handleCancel, handleCreate, formRef, singleRestaurant } = this.props
    return (
      <CollectionCreateForm
        wrappedComponentRef={formRef}
        visible={shoModal}
        isSubmit={isSubmit}
        onCancel={handleCancel}
        onCreate={handleCreate}
        singleRestaurant={singleRestaurant}
      />
    )
  }
}
